import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TaxBucketMoneyMove from '../components/TaxBucketMoneyMove';
import { TAX_BUCKET_ADD } from '../constants';
import { validateFeatureFlag } from '../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../constants/general';
import { VIEWS_MAP } from '../../../router/constants';
import PageLayout from '../../../generic-components/PageLayout/PageLayout';
import PageHeader from '../../../generic-components/PageHeader/PageHeader';

const TaxBucketAdd = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  useEffect(() => {
    if (!validateFeatureFlag(FEATURE_FLAG.TAX_BUCKET)) navigate(`/${VIEWS_MAP.DASHBOARD}`);
  }, []);

  return (
    <PageLayout>
      <PageHeader title={t(TAX_BUCKET_ADD.PAGE_HEADER)} pathToNavigate='/tax-bucket-dashboard/:main' />
      <div className='w-full h-[70dvh]'>
        <TaxBucketMoneyMove pullFromTaxBucket={false} />
      </div>
    </PageLayout>
  );
};

export default TaxBucketAdd;
